// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__23kpz","header":"PatientQuestionnaire_header__wGXCF","info":"PatientQuestionnaire_info__3s_qz"};